<div
  class="flex items-center text-[2rem]"
  [ngClass]="{
    'text-system-success': value >= 0,
    'text-system-error': value < 0
  }"
  id="dashboard__direction-indicator"
>
  <mat-icon
    svgIcon="{{ value >= 0 ? 'green-arrow-up' : 'red-arrow-down' }}"
  ></mat-icon>
  {{ value }}%
</div>
<p
  class="text-[0.75rem] text-grayscale-heavy"
  id="dashboard__direction-indicator-text"
>
  {{
    value >= 0
      ? (upDirectionLabel | transloco)
      : (downDirectionLabel | transloco)
  }}
  {{ comparedWith | transloco }}
</p>
